

export class EmployeeAllowanceDto implements IEmployeeAllowanceDto {
    grossAmount!: number;
    basicAlw!: number;
    dearnessAlw!: number;
    houseRentAlw!: number;
    medicalAlw!: number;
    dailyTravellingAlw!: number;
    performanceAlw!: number;
    otherAlw!: number;
    productionAlw!: number;
    fuelAlw!: number;
    pfDetectable!: boolean;
    esicDetectable!: boolean;
    ptDetectable!: boolean;
    lwfDetectable!: boolean;

    constructor(data?: IEmployeeAllowanceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grossAmount = _data["grossAmount"];
            this.basicAlw = _data["basicAlw"];
            this.dearnessAlw = _data["dearnessAlw"];
            this.houseRentAlw = _data["houseRentAlw"];
            this.medicalAlw = _data["medicalAlw"];
            this.dailyTravellingAlw = _data["dailyTravellingAlw"];
            this.performanceAlw = _data["performanceAlw"];
            this.otherAlw = _data["otherAlw"];
            this.productionAlw = _data["productionAlw"];
            this.fuelAlw = _data["fuelAlw"];
            this.pfDetectable = _data["pfDetectable"];
            this.esicDetectable = _data["esicDetectable"];
            this.ptDetectable = _data["ptDetectable"];
            this.lwfDetectable = _data["lwfDetectable"];
        }
    }

    static fromJS(data: any): EmployeeAllowanceDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeAllowanceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grossAmount"] = this.grossAmount;
        data["basicAlw"] = this.basicAlw;
        data["dearnessAlw"] = this.dearnessAlw;
        data["houseRentAlw"] = this.houseRentAlw;
        data["medicalAlw"] = this.medicalAlw;
        data["dailyTravellingAlw"] = this.dailyTravellingAlw;
        data["performanceAlw"] = this.performanceAlw;
        data["otherAlw"] = this.otherAlw;
        data["productionAlw"] = this.productionAlw;
        data["fuelAlw"] = this.fuelAlw;
        data["pfDetectable"] = this.pfDetectable;
        data["esicDetectable"] = this.esicDetectable;
        data["ptDetectable"] = this.ptDetectable;
        data["lwfDetectable"] = this.lwfDetectable;
        return data; 
    }
}

export interface IEmployeeAllowanceDto {
    grossAmount: number;
    basicAlw: number;
    dearnessAlw: number;
    houseRentAlw: number;
    medicalAlw: number;
    dailyTravellingAlw: number;
    performanceAlw: number;
    otherAlw: number;
    productionAlw: number;
    fuelAlw: number;
    pfDetectable: boolean;
    esicDetectable: boolean;
    ptDetectable: boolean;
    lwfDetectable: boolean;
}

